import React, { Component } from 'react';
import styled from 'styled-components';
import apiRequest from '../utils/apiRequest';
import findIdByPath from '../utils/findIdByPath';
import { SecondaryTitle, CardSpacing, CardContent } from './CommonUiComponents';
import { lightGray } from '../utils/colors';
import ExpandableItem from './ExpandableItem';
import ErrorBoundary from './ErrorBoundary';

const ReflectionBody = styled.div`
  padding: 0 3.5rem 1rem 3.5rem;
  font-size: 0.875rem;
`;

const BoldText = styled.span`
  font-weight: 600;
`;

const ThinText = styled.p`
  font-weight: 300;
  margin-top: 0;

  &:first-child {
    margin-bottom: 2rem;
  }
`;

const ReflectionQA = styled.div`
  margin: 2rem 0;
`;

const Quote = styled.blockquote`
  margin: 0.75rem 0;
  font-weight: 500;
  font-size: 0.875rem;
  font-style: normal;
`;

const ReflectionText = styled.div`
  padding: 1.5rem 1.5rem;
  font-size: 0.875rem;
  border-radius: 10px;
  background-color: #f5f6f6;
  color: ${lightGray};
  font-style: italic;
  font-family: 'Source Sans Pro';
  margin: 1rem -1.25rem;
`;

function flatten(parts) {
  const arr = [];

  parts.forEach(p => {
    p.chapters.forEach(c => {
      arr.push(c);
    });
  });

  return arr;
}

const Reflection = ({ chapters, part, reflections, reflectionData }) => {
  return (
    <ExpandableItem label={part}>
      {chapters.map((item, k) => {
        const chapterReflections = reflectionData.find(
          r => r.chapter_id === item.key
        );

        if (!chapterReflections) return null;

        return (
          <ReflectionBody key={item.key}>
            <ThinText>
              Fra <BoldText>kapittel {k + 1}</BoldText>
            </ThinText>
            {chapterReflections &&
              chapterReflections.reflections &&
              chapterReflections.reflections.map((r, rIndex) => {
                const reflectionAnswer = reflections.filter(
                  a => a.reflection_id === r.id && a.answer !== ''
                );

                return (
                  <ReflectionQA key={r.id}>
                    {r.reflection.map((d, dIndex) => {
                      return (
                        <div key={dIndex}>
                          <Quote>{d.question}</Quote>
                          {reflectionAnswer
                            .filter(
                              c => parseInt(c.question_order, 10) === dIndex + 1
                            )
                            .map((c, cIndex) => {
                              return (
                                <ReflectionText key={cIndex}>
                                  {c ? c.answer : 'Ingen refleksjoner enda.'}
                                </ReflectionText>
                              );
                            })}
                        </div>
                      );
                    })}
                  </ReflectionQA>
                );
              })}
          </ReflectionBody>
        );
      })}
      ;
    </ExpandableItem>
  );
};

class Reflections extends Component {
  state = {
    reflectionData: [],
    userReflections: []
  };

  componentDidMount() {
    this.fetchReflections();
    this.fetchUserReflections();
  }

  async fetchReflections() {
    const response = await apiRequest(
      'wordpress',
      `reflections/v1/book/?id=${findIdByPath()}`
    );

    if (!response.status) {
      this.setState({
        reflectionData: flatten(response)
      });
    }
  }

  async fetchUserReflections() {
    const response = await apiRequest('wordpress', 'reflections/v1/list');

    this.setState({
      userReflections: response
    });
  }

  render() {
    const { parts } = this.props;
    const { reflectionData, userReflections } = this.state;

    if (!parts) return null;

    return (
      <ErrorBoundary>
        <CardSpacing hugger>
          <CardContent>
            <SecondaryTitle highlight>Mine refleksjoner</SecondaryTitle>
          </CardContent>
        </CardSpacing>
        {parts.map(p => (
          <Reflection
            key={p.key}
            part={p.name}
            chapters={p.chapters}
            reflections={userReflections}
            reflectionData={reflectionData}
          />
        ))}
      </ErrorBoundary>
    );
  }
}

export default Reflections;



// WEBPACK FOOTER //
// ./src/components/Reflections.js